import { html, LitElement, nothing, type CSSResultGroup } from 'lit'
import { customElement } from 'lit/decorators.js'
import { DeliveryMatchActionsContext, DeliveryMatchDropoffMethodModeContext, DeliveryMatchDropoffMethodsContext, DeliveryMatchGeolocationContext, DeliveryMatchSelectedMethodContext, NO_SELECTED_METHOD, type DeliveryMatchActionsContextType, type DeliveryMatchCurrencyGeolocationType, type DeliveryMatchDropoffMethodModeContextType, type DeliveryMatchDropoffMethodsContextType, type DeliveryMatchSelectedMethodContextType } from './provider.js'
import { CSCDeliveryMatchMethodDropoffContent } from './delivery-match-method-dropoff.js'
import { consume } from '@lit/context'
import { classMap } from 'lit/directives/class-map.js'
import { formatCenter } from './utils.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { mapStyle } from './delivery-match-dropoff-method-selector-map.style.js'
import { renderDefaultPin, renderSelectedPin } from './delivery-match-dropoff-method-selector-map-pins.js'
import type { DropoffMethod } from './api/shipment-methods.js'
import { GoogleMapsMapProviderActionsContext, GoogleMapsMapProviderActionsContextType, GoogleMapsMapProviderCenterContext, GoogleMapsMapProviderZoomLevelContext, type LatLng } from './map-provider.js'

@customElement('csc-delivery-match-dropoff-method-selector-map')
export class CSCDeliveryMatchDropoffMethodSelectorMap extends LitElement {
  static override styles?: CSSResultGroup = [hostStyle, mapStyle]

  @consume({ context: DeliveryMatchDropoffMethodModeContext, subscribe: true })
  dropoffMethodMode!: DeliveryMatchDropoffMethodModeContextType

  @consume({ context: DeliveryMatchActionsContext })
  private actions!: DeliveryMatchActionsContextType

  @consume({ context: GoogleMapsMapProviderActionsContext })
  private mapActions!: GoogleMapsMapProviderActionsContextType

  @consume({ context: DeliveryMatchDropoffMethodsContext, subscribe: true })
  private dropoffMethods!: DeliveryMatchDropoffMethodsContextType

  @consume({ context: DeliveryMatchSelectedMethodContext, subscribe: true })
  private selectedMethod!: DeliveryMatchSelectedMethodContextType

  @consume({ context: DeliveryMatchGeolocationContext, subscribe: true })
  private initialGeolocation?: DeliveryMatchCurrencyGeolocationType
  
  @consume({ context: GoogleMapsMapProviderCenterContext, subscribe: true })
  private geolocation?: LatLng

  @consume({ context: GoogleMapsMapProviderZoomLevelContext, subscribe: true })
  private zoomLevel!: number

  private renderPin(methodId: string, isSelected: boolean) {
    if (isSelected) {
      return renderSelectedPin(methodId)
    }
    return renderDefaultPin(methodId)
  }

  private getSelectedMethodFromDropoffMethods() {
    if (this.selectedMethod == NO_SELECTED_METHOD) {
      return NO_SELECTED_METHOD
    }

    if (this.dropoffMethods.map(m => m.methodId).includes(this.selectedMethod)) {
      return this.dropoffMethods.find(m => m.methodId == this.selectedMethod) as DropoffMethod
    } else {
      return NO_SELECTED_METHOD
    }


    return NO_SELECTED_METHOD
  }

  private get mapCenter() {
    return formatCenter(this.geolocation || this.initialGeolocation)
  }
  override render() {
    const selectedMethod = this.getSelectedMethodFromDropoffMethods()
    const pins = this.dropoffMethods.map((m) => {
      return {
        methodId: m.methodId,
        name: m.name,
        lat: m.address.latitude,
        lon: m.address.longitude
      }
    })

    return html`
      <div class="${classMap(
          {
            'map-wrapper': true,
            hidden: this.dropoffMethodMode !== 'map'
          }
        )}">
        <div class="map">
            <gmp-map
              rendering-type="vector"
              center="${this.mapCenter}"
              zoom="${this.zoomLevel}"
              map-id="DELIVERY_MATCH_GOOGLE_MAP"
            >
              ${pins.map(pin => html`
                <gmp-advanced-marker
                  position="${pin.lat},${pin.lon}"
                  title="${pin.name}"
                  gmp-clickable
                  @click="${() => {
                    this.mapActions.setCenter({
                      lat: pin.lat,
                      lon: pin.lon
                    })
                    this.mapActions.setZoomLevel(16)
                    this.actions.setSelectedMethod(pin.methodId)
                  }}"
                >
                  ${this.renderPin(pin.methodId, pin.methodId === this.selectedMethod)}
                </gmp-advanced-marker>
              `)}
            </gmp-map>
        </div>
        ${selectedMethod !== NO_SELECTED_METHOD ? html`
          <div class="selected-method">
            ${new CSCDeliveryMatchMethodDropoffContent({ selectedMethod })}
          </div>`
        : nothing}
      </div>
    `
  }
}
